import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/device/distinct_names";

export class GetDistinctInstallationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetDistinctInstallationsResData> {
        var res = await this.executeCommand();
        return new GetDistinctInstallationsResData(res);
    }
}

export class GetDistinctInstallationsResData extends ApiGenericResponse {
    installationNames: string[];

    constructor(response: AxiosResponse) {
        super(response);
        this.installationNames = null;

        if (response.data && response.data.Payload && Array.isArray(response.data.Payload) && response.data.Payload.length) this.installationNames = response.data.Payload;
    }
}
